/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Header/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Header({
  children,
  viewPath = "/App/Account/PatientNotifications/Content/Content/Content/Alerts/Alert/Header"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let alertCreatedByPersonValueData = fromData.useDataValue({ viewPath,
context: 'alert',
path: 'createdByPerson',
})
let constantData = 'N/A'
let aggregateData = fromAggregate.any(alertCreatedByPersonValueData, constantData)
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let alertLastModifiedValueData = fromData.useDataValue({ viewPath,
context: 'alert',
path: 'lastModified',
})
  return (<React.Fragment
>
<div
  data-testid="Header.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z2wmEtq': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral700}
 data="alert.createdByPerson"
 data="'N/A'"
 aggregate="/Simple/Data/aggregate.js any"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 marginTop={2}
 data="alert.lastModified"
 text={alertLastModifiedValueData}
 color={dtColorsNeutral700}
/>
</div>
{children}
</React.Fragment>)
}